import React from "react";
import "../../CSS/Industries.css";

function RetailEcommerce() {
    return (
        <>
           
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">

                    <div className="industry-detail-hero-content">



                        <h1>
                            Solutions for Retail<br /> & E-Commerce
                        </h1>

                        <p style={{ color: '#FF7D37' }}>
                            Build digital retail experiences with websites,
                            e-commerce platforms, business applications,
                            inventory systems, and customized solutions.
                        </p>

                    </div>

                </div>
            </section>


            <section className="industry-detail-section">

                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">


                            <h2>
                                Build Better Digital Retail Experiences
                            </h2>

                            <p>
                                Retail businesses need technology that connects
                                products, customers, orders, inventory, and
                                business operations.
                            </p>

                            <p>
                                We develop e-commerce websites, custom
                                applications, inventory systems, and digital
                                platforms for retail businesses.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/retail.png"
                                alt="Retail and Ecommerce Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>

            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for <br />Retail & E-Commerce</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-cart3"></i>
                            <h3>E-Commerce Websites</h3>
                            <p>Online stores designed around your products and customers.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-box-seam"></i>
                            <h3>Inventory Management</h3>
                            <p>Systems for managing product and inventory information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-bag-check"></i>
                            <h3>Order Management</h3>
                            <p>Digital workflows for managing customer orders.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-graph-up-arrow"></i>
                            <h3>Sales Analytics</h3>
                            <p>Business insights through reports and dashboards.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default RetailEcommerce;